/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.OrderStatus.Offline.Headline';
export const Description = 'Website.OrderStatus.Offline.Description';
